import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { useState } from "react";
import './EditHotelDrawer.css'

export default function EditHotelDrawer({ isOpen, onClose, data, onSave }) {

  const [formData, setFormData] = useState({
    island: data?.island || "",
    city: data?.city || "",
    adress: data?.adress || "",
    type: data?.type || "",
    desc: data?.desc || ""
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  if (!isOpen) return null;

  return createPortal(
    <AnimatePresence>
      <motion.div
        className="drawer-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="drawer"
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ duration: 0.3 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="drawer-header">
            <h3>Modifier l’hôtel</h3>
            <button onClick={onClose}>✕</button>
          </div>

          <div className="drawer-body">

            <div>
                <label className="section-label">Île</label>
                <div className="select-grid">

                    {["Ngazidja", "Moheli", "Anjouan"].map(option => (
                    <div
                        key={option}
                        className={`select-card ${
                        formData.island === option ? "selected" : ""
                        }`}
                        onClick={() => setFormData(prev => ({
                        ...prev,
                        island: option
                        }))}
                    >
                        {option}
                    </div>
                    ))}

                </div>
                </div>
            <div>
                <label className="section-label">Ville</label>
                <input
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Ville"
                />
            </div>
            <div>
                <label className="section-label">Adresse</label>
                <input
                name="adress"
                value={formData.adress}
                onChange={handleChange}
                placeholder="Adresse"
                />
            </div>

            <div>
                <label className="section-label">Type</label>
                    <div className="select-grid">

                        {["Hotel", "Chambre d'hôte", "Appartement&Maison"].map(option => (
                        <div
                            key={option}
                            className={`select-card ${
                            formData.type === option ? "selected" : ""
                            }`}
                            onClick={() => setFormData(prev => ({
                            ...prev,
                            type: option
                            }))}
                        >
                            {option === "Hotel" && "Hôtel"}
                            {option === "Chambre d'hôte" && "Chambre d’hôte"}
                            {option === "Appartement&Maison" && "Maison & Appartement"}
                        </div>
                        ))}

                    </div>
            </div>
            <div>
                <label className="section-label">Description</label>
                <textarea
                name="desc"
                value={formData.desc}
                onChange={handleChange}
                placeholder="Description"
                />
            </div>

          </div>

          <div className="drawer-footer">
            <button className="modern-button" onClick={() => onSave(formData)}>
              Enregistrer
            </button>
          </div>

        </motion.div>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
}